import { vesselNameHeading } from './vesselNameHeading';

export const vesselNameHeadingForOrders = {
    ...vesselNameHeading,
    colId: 'orderVessel',
};
